export default __webpack_public_path__ + "assets/table_row_widget.10dc048a34c33d947d9d5f460f409cf1.svg";